/**
 * S1.2 — the clock skew between this browser and the tournament server.
 * `tournamentStatusFrom` is PURE and takes `nowMs` as an input, so this is
 * the ONE place that corrects "now" before handing it in — a tiny
 * module-level pair, not a store. `DetailsPanel/model.ts` calls `setSkew`
 * once per details response; every caller that needs "now" for a status
 * input reads `nowServerMs()` instead of `Date.now()` directly. The same
 * correction the old T-10 s late-join gate made (`TournamentPlay.tsx`'s own
 * `skewMs`, L1068-1072).
 */

/** a malformed `server_time` (or a genuinely wrong local clock) cannot push
 * every countdown further than this. */
const MAX_SKEW_MS = 5 * 60 * 1000;

let skewMs = 0;

/** clamped to ±5 min; a non-finite `ms` (no `server_time` on the response,
 * `Date.parse` of an empty string) resets the skew to 0. */
export const setSkew = (ms: number): void => {
  skewMs = Number.isFinite(ms)
    ? Math.max(-MAX_SKEW_MS, Math.min(MAX_SKEW_MS, ms))
    : 0;
};

/** "now", corrected by the last `setSkew`. */
export const nowServerMs = (): number => Date.now() + skewMs;
